<template>
    <b-form class="hg-form event-form">
        <!--CONFLICTED-EVENTS-->
        <div class="hg-notification error " v-if="conflicted_events.length>0 && !evt_processing">
            <div v-if="checkingConflictedEvents" style="position:absolute">
                <font-awesome-icon :icon="['fas', 'futbol']" spin/>
            </div>
            <font-awesome-icon  :icon="['fas','exclamation-triangle']" style="color:var(--hg-red)"/> &nbsp;
            <strong v-i18n="'EVENTS_SCHEDULE_ERROR'" /><br/>
            <small v-i18n="'EVENTS_SCHEDULE_ERROR_SUGGESTION'" />
            <ul>
                <li v-for="evt in conflicted_events" :key="evt.id">
                    <router-link :to="'/events/' + evt.id">
                        <strong>{{$hisport.eventTitle(evt,{})}}</strong>&nbsp;
                        <span class="datetime" v-if="evt.start_timestamp">{{evt.start_timestamp | moment("ddd D MMM yyyy (HH:mm")}} &#8674; {{evt.end_timestamp | moment("HH:mm)")}}</span>
                        <span class="datetime" v-if="evt.timestamp">{{evt.timestamp | moment("ddd D MMM yyyy HH:mm")}}</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <!--GAME FIELD-->
        <b-input-group  id="input-gf" 
                        label-for="gf" 
                        :label="$hisport.i18n('GAME_FIELD')">
                <v-select   v-model="game_field" 
                            :options="game_fields"
                            class="hg-select" 
                            :disabled="!!(event && event.video)"
                            required>
                    <template slot="selected-option" slot-scope="option">
                        <img    :src="$hisport.absolute(option.logo, {default:'/images/game_field_default.png', w: 64})" 
                                v-img-fallback="'/images/game_field_default.png'"
                                height="20px" width="20px"/>
                        <span v-i18n="option.name" />
                    </template>
                    <template slot="option" slot-scope="option">
                        <img    :src="$hisport.absolute(option.logo, {default:'/images/game_field_default.png', w: 64})" 
                                v-img-fallback="'/images/game_field_default.png'"
                                height="20px" width="20px"/> &nbsp;
                        <span v-i18n="option.name" />
                    </template>
                </v-select>
            <b-input-group-append>
                <b-button class="btn btn-transparent" 
                        @click.prevent="$emit('changedForce',game_field)">
                    <font-awesome-icon :icon="['fas', 'sync-alt']" :spin="processing"/>
                </b-button>
            </b-input-group-append>
        </b-input-group>
        
        <!--EVENT TYPE-->
        <b-form-group   id="input-et" label-for="et" 
                        v-if="game_field &&
                            $hisport.options.platform.CONFIGURATION.ENABLE_NON_GENERIC_EVENT_TYPES &&
                            $hisport.options.platform.CONFIGURATION.SHOW_NON_GENERIC_EVENT_TYPES"
                        :label="$hisport.i18n('SELECT_EVENT_TYPE')">
            <v-select   v-model="event_type" 
                        :options="eventTypes"
                        :reduce="t => t.id"
                        class="hg-select" 
                        required>
                <template slot="selected-option" slot-scope="option">
                    <span v-i18n="option.label" />
                </template>
                <template slot="option" slot-scope="option">
                    <span v-i18n="option.label" />
                </template>
            </v-select>
        </b-form-group>
        <!--SPORT-->
        <b-form-group   id="input-sp" 
                        label-for="sp" 
                        v-if="$hisport.options.platform.CONFIGURATION.ENABLE_NON_GENERIC_EVENT_TYPES &&
                                $hisport.options.platform.CONFIGURATION.SHOW_SPORTS_ON_EVENTS"
                        :label="$hisport.i18n('SELECT_SPORT')">
            <v-select   v-model="sport" 
                        :options="sports"
                        class="hg-select" 
                        required>
                <template slot="selected-option" slot-scope="option">
                    <span v-i18n="option.name" />
                </template>
                <template slot="option" slot-scope="option">
                    <span v-i18n="option.name" />
                </template>
            </v-select>
        </b-form-group>

        <!--CATEGORY-->
        <b-form-group   id="input-cat" label-for="cat" 
                        v-if="event_type != $hisport.event_types.OTHER_GENERIC_VIDEO && categories.length > 0"
                        :label="$hisport.i18n('SELECT_CATEGORY')">
            <v-select   v-model="category" 
                        :options="categories"
                        class="hg-select" 
                        required>
                <template slot="selected-option" slot-scope="option">
                    <span v-i18n="option.name" />
                </template>
                <template slot="option" slot-scope="option">
                    <span v-i18n="option.name" />
                </template>
            </v-select>
        </b-form-group>
        <!--TITLE-->
        <b-form-group   v-if="[$hisport.event_types.OTHER_GENERIC_VIDEO].indexOf(event_type)>=0"
                        id="input-grp-id" label-for="grp-id" 
                        :label="$hisport.i18n('EVENT_TITLE')">
            <b-form-input   id="grp-id" class="hg-input" v-model="title"  />
        </b-form-group>

        <!--VISIBILITY-->
        <b-form-group   id="input-vs" label-for="vs" 
                        v-if="$hisport.options.platform.CONFIGURATION.ENABLE_NON_GENERIC_EVENT_TYPES"
                        :label="$hisport.i18n('VISIBILITY')">
            <v-select   v-model="visibility" 
                        :options="visibilityTypes"
                        class="hg-select" 
                        :reduce="t => t.id"
                        required>
                <template slot="selected-option" slot-scope="option">
                    <span v-i18n="'VISIBILITY_' + option.label" /> 
                </template>
                <template slot="option" slot-scope="option">
                    <span v-i18n="'VISIBILITY_' + option.label" />
                </template>
            </v-select>
        </b-form-group>

        <!--PASSWORD-->
        <b-form-group   v-if="  $hisport.options.platform.CONFIGURATION.ENABLE_PASSWORD_PROTECTED_EVENTS && 
                                visibility == $hisport.visibility_types.PASSWORD && 
                                [$hisport.event_types.OTHER_GENERIC_VIDEO].indexOf(event_type)>=0 &&
                                $hisport.options.platform.CONFIGURATION.SHOW_PASSWORD_PROTECTED_EVENTS"
                        id="input-grp-id" label-for="grp-id" 
                        :label="$hisport.i18n('EVENT_PASSWORD')">
            <b-form-input   id="grp-id" class="hg-input" v-model="password"  />
        </b-form-group>

        <!--START TIMESTAMP-->
        <b-form-group   v-if="!start_immediately" 
                        id="input-grp-start" label-for="grp-start" 
                        :label="$hisport.i18n('EVENT_TS_START')">
            <b-form-input   id="grp-start" class="hg-input" :value="moment(start_timestamp).format(FORMAT_LOCALE)" @input="changeStart({ value: moment($event, FORMAT_LOCALE).toDate() })" :disabled="!!event && !!event.video" :min="moment(min_date).format(FORMAT_LOCALE)" type="datetime-local"/>
        </b-form-group>

        <!--DURATION-->
        <b-form-group   id="input-grp-duration" label-for="grp-duration" 
                        :label="$hisport.i18n('EVENT_DURATION')"
                        v-if="!event || !event.video" >
            <v-select   v-model="duration" 
                        :options="durations"
                        :reduce="t => t.value"
                        class="hg-select" 
                        required>
                <template slot="selected-option" slot-scope="option">
                    {{option.text}} 
                </template>
                <template slot="option" slot-scope="option">
                    {{option.text}} 
                </template>
            </v-select>
        </b-form-group>

        <!--END TIMESTAMP-->
        <b-form-group   id="input-grp-end" label-for="grp-end"
                        :label="$hisport.i18n('EVENT_TS_END')">
            <b-form-input   id="grp-end" class="hg-input" :value="moment(end_timestamp).format(FORMAT_LOCALE)" :min="min_date" type="datetime-local" disabled/>
        </b-form-group>

        <!--TEAM HOME-->
        <b-form-group   id="input-th" label-for="th" 
                        v-if="  $hisport.options.platform.CONFIGURATION.ENABLE_CLUBS && 
                                all_teams.length>0 && 
                                event_type != $hisport.event_types.OTHER_GENERIC_VIDEO"
                        :label="$hisport.i18n('TEAM_HOME')">
            <v-select   v-model="team_home" 
                        :options="homeTeamsFiltered"
                        taggable
                        :create-option="x => ({id: null, name: x})"
                        class="hg-select" 
                        required>
                <template slot="selected-option" slot-scope="option">
                    <span v-if="option && option.name">
                        <img    :src="$hisport.absolute(option.logo, {default:'/images/team_default.png', w: 64})" 
                                v-img-fallback="'/images/team_default.png'"
                                height="20px" width="20px"/>
                        <span v-i18n="option.name" /> 
                        <span v-if="!category"> - {{option.category_name}}</span> 
                        <span class="pull-right" v-if="option.id && !option.is_main" >
                        <font-awesome-icon :icon="['fas','exclamation-triangle']"/>
                        </span>
                    </span>
                </template>
                <template slot="option" slot-scope="option">
                    <img    :src="$hisport.absolute(option.logo, {default:'/images/team_default.png', w: 64})" 
                            v-img-fallback="'/images/team_default.png'"
                            height="20px" width="20px"/>
                    <span v-i18n="option.name" /> 
                    <span v-if="!category"> - {{option.category_name}}</span> 
                    <span class="pull-right" v-if="option.id && !option.is_main" >
                    <font-awesome-icon :icon="['fas','exclamation-triangle']"/>
                    </span>
                </template>
            </v-select>
        </b-form-group>
        <small class="hg-notification error" v-if="team_home && team_home.id && !team_home.is_main" v-i18n="'CONFIRM_NOT_HOME_OR_FOREIGN_TEAM'"/>

        <!--TEAM FOREIGN-->
        <b-form-group   id="input-tf" label-for="tf" 
                        v-if="  $hisport.options.platform.CONFIGURATION.ENABLE_CLUBS && 
                                all_teams.length>0 && 
                                event_type == $hisport.event_types.MATCH"
                        :label="$hisport.i18n('TEAM_FOREIGN')">
            <v-select   v-model="team_foreign" 
                        :options="foreignTeamsFiltered"
                        taggable
                        :create-option="x => ({id: null, name: x})"
                        class="hg-select" 
                        required>
                <template slot="selected-option" slot-scope="option">
                    <span v-if="option && option.name">
                        <img    :src="$hisport.absolute(option.logo, {default:'/images/team_default.png', w: 64})" 
                                v-img-fallback="'/images/team_default.png'"
                                height="20px" width="20px"/>
                        <span v-i18n="option.name" /> 
                        <span v-if="!category"> - {{option.category_name}}</span> 
                        <span class="pull-right" v-if="option.id && !option.is_main" >
                        <font-awesome-icon :icon="['fas','exclamation-triangle']"/>
                        </span>
                    </span>
                </template>
                <template slot="option" slot-scope="option">
                    <img    :src="$hisport.absolute(option.logo, {default:'/images/team_default.png', w: 64})" 
                            v-img-fallback="'/images/team_default.png'"
                            height="20px" width="20px"/>
                    <span v-i18n="option.name" /> 
                    <span v-if="!category"> - {{option.category_name}}</span> 
                    <span class="pull-right" v-if="option.id && !option.is_main" >
                    <font-awesome-icon :icon="['fas','exclamation-triangle']"/>
                    </span>
               </template>
            </v-select>
        </b-form-group>
        <small class="hg-notification error" v-if="team_foreign && team_foreign.id && !team_foreign.is_main" v-i18n="'CONFIRM_NOT_HOME_OR_FOREIGN_TEAM'"/>

        <b-form-checkbox v-if="$hisport.options.platform.CONFIGURATION.ENABLE_EVENT_FULLVIDEOUPLOAD && new Date(end_timestamp) > Date.now()" class="btn checkbox" v-model="has_video" id="grp-hibox-fullvideo"> {{ $hisport.i18n('ENABLE_EVENT_FULLVIDEOUPLOAD')}} </b-form-checkbox>
        <b-row class="buttons">
            <b-col cols="8" v-if="!launching && start_immediately">
            <!--CREATE/UPDATE & START NEW EVENT-->
            <b-button v-i18n="!!event?'UPDATE_AND_START_RECORDING':'CREATE_AND_START_RECORDING'" 
                    class="btn"
                    variant="primary" 
                    :class="{valid: scheduleValidation && title.length>0}" 
                    :disabled="!isFormValid()"
                    @click.prevent="saveAndStartRecording()"/>
            <b-button v-i18n="'DELETE_EVENT'" 
                    variant="danger" 
                    class="btn"
                    v-if="event && !event.video"
                    @click.prevent="deleteEvent()"/>
            </b-col>
            <b-col cols="4">
            <!--START/SCHEDULE-->
            <b-button v-if="$hisport.options.platform.CONFIGURATION.ENABLE_EVENT_CALENDAR" v-i18n="'SCHEDULE_EVENT'" 
                    variant="info"
                    class="pull-right"
                    v-show="start_immediately && (!event || !event.video)"
                    @click.prevent="start_immediately = false"/>
            <b-button  v-i18n="'START_IMMEDIATELY'" 
                    variant="info"
                    v-show="!start_immediately && (!event || !event.video)"
                    @click.prevent="start_immediately = true"/>
            </b-col>
            <b-col cols="8" v-if="!launching && !start_immediately">
            <b-button v-i18n="'DELETE_EVENT'" 
                    variant="danger" 
                    class="btn pull-right"
                    v-if="!!event && !!$hisport.permissions.isAdmin()"
                    @click.prevent="deleteEvent()"/>
            <!--SCHEDULE EVENT-->
            <b-button v-i18n="'CLONE_EVENT'" 
                    variant="warning" 
                    class="btn pull-right"
                    v-show="!!event && !!$hisport.options.platform.CONFIGURATION.ENABLE_EVENT_CLONE && !!$hisport.permissions.isAdmin()"
                    @click.prevent="cloneEvent()"/>
            <b-button v-i18n="!!event?'UPDATE_EVENT':'CREATE_EVENT'" 
                    variant="primary" 
                    class="btn pull-right"
                    :class="{valid: scheduleValidation && title.length>0}" 
                    :disabled="!isFormValid()"
                    @click.prevent="checkAndSave(true)"/>
            </b-col>
        </b-row>
        <event-share :event="event" v-if="!!event"/>
        <font-awesome-icon :icon="['fas', 'futbol']" spin v-if="launching"/>
    </b-form>
</template>
<script>
// const DEFAULT_DURATION = 2 * 60 * 60 * 1000;
const FORMAT_LOCALE = 'YYYY-MM-DDTHH:mm'
const MIN_FUTURE_START = 5 * 60 * 1000;
import moment               from "moment";
import eventShare from "../_components/event_share.vue";
export default {
    props:{
        event: {type: Object, default: function(){ return null} },
        processing: {type: Boolean},
        gameFieldId: {type: Number}
    },
    components:{
        eventShare
    },

    beforeDestroy(){
        clearTimeout(this.schedTimeout);
        this.exited = true;
    },
    mounted(){
        this.init();
    },
    data(){
        var self = this;
        return {
            moment,
            FORMAT_LOCALE,
            /*left_margin:    Screen.mainScreen.widthDIPs - 80,*/
            game_field:     undefined,
            game_fields:    [],
            gf_progress:    false,
            events_bygf:    {},
            all_teams:      [],
            all_categories: [],
            all_seasons:    [],
            home_teams:     [],
            foreign_teams:  [],
            event_type:     this.$hisport.options.platform.CONFIGURATION.ENABLE_NON_GENERIC_EVENT_TYPES ? this.$hisport.event_types.OTHER_GENERIC_VIDEO : this.$hisport.event_types.MATCH,
            durations:      this.$hisport.options.EVENT_DURATIONS.filter(function(x){ return self.$hisport.permissions.isAdmin() || x.value >= 30 }),
            team_home:      { },
            team_foreign:   { },
            start_timestamp:this.getStartTimestamp(),
            end_timestamp:  this.getStartTimestamp(),

            sports:         [],
            sport:          undefined,
            categories:     [],
            category:       undefined,
            seasons:        [],
            season:         undefined,
            visibility:     this.$hisport.options.platform.CONFIGURATION.ENABLE_PASSWORD_PROTECTED_EVENTS ? this.$hisport.visibility_types.PASSWORD : this.$hisport.visibility_types.PRIVATE,
            launching:      false,
            evt_processing:     false,
            start_immediately:     true,
            has_video:      this.$hisport.options.platform.CONFIGURATION.DEFAULT_EVENT_FULLVIDEOUPLOAD,
            chunks_upload:  this.$hisport.options.platform.CONFIGURATION.ENABLE_EVENT_CHUNKSUPLOAD,

            title:          "",
            password:       this.$hisport.options.platform.CONFIGURATION.ENABLE_PASSWORD_PROTECTED_EVENTS && this.$hisport.generatePassword(6),
            key:            0,
            duration:       this.$hisport.options.platform.default_event_duration || 120,
            schedTimeout:  null,
            scheduleValidation: undefined,
            conflicted_events: [],
            checkingConflictedEvents: false,
            exited: false
        }
    },
    computed: {
        visibilityTypes(){
            if(this.$hisport.options.platform.CONFIGURATION.ENABLE_PASSWORD_PROTECTED_EVENTS){
                return [
                    {id: this.$hisport.visibility_types.PASSWORD, label: 'PASSWORD'},
                ]
            }
            return  [
                    {id: this.$hisport.visibility_types.PRIVATE, label: 'PRIVATE'},
                    {id: this.$hisport.visibility_types.ALL_CLUB, label: ((
                        (this.event_type == this.$hisport.event_types.MATCH || this.event_type == this.$hisport.event_types.TRAINING)
                        && this.team_home.id
                        )?'ALL_CLUB_AND_STRUCTURE':'ALL_CLUB_ONLY_STRUCTURE')}
                    ]
        },
        homeTeamsFiltered(){
            if(!this.$hisport.options.platform.CONFIGURATION.ENABLE_CLUBS) return [];
            if(!this.game_field) return this.home_teams;
            var self = this;
            // return this.home_teams.filter(function(x){
            //     if(Array.isArray(self.game_field.supported_sports)){
            //         return self.game_field.supported_sports.indexOf(x.id_sport)>=0
            //     }
            //     return false;
            // })
            return this.all_teams.filter(function(x){
                return !self.category || x.id_category == self.category.id;
            })
            .map(function(x){
                var is_main = (!!self.home_teams.find(y=>y.id == x.id));
                var category = self.all_categories.find(y=>y.id == x.id_category )
                return {
                    is_main:    is_main,
                    logo:       x.logo,
                    name:       x.name,
                    id:         x.id,
                    category_name: category?category.name:"Nessuna categoria"
                }
                }).sort(function(x){
                    return x.is_main?-1:1
                })
        },
        foreignTeamsFiltered(){
            if(!this.$hisport.options.platform.CONFIGURATION.ENABLE_CLUBS) return [];
            if(!this.game_field) return this.all_teams;
            var self = this;
            return this.all_teams
                .filter(function(x){
                    return !self.category || x.id_category == self.category.id;
                })
                .map(function(x){
                    var is_main = !!((!!self.home_teams.find(y=>y.id == x.id)) || (!!self.foreign_teams.find(y=>y.id == x.id)));
                    var category = self.all_categories.find(y=>y.id == x.id_category )
                    return {
                        is_main:  is_main,
                        logo:     x.logo,
                        name:     x.name,
                        id:       x.id,
                        category_name: category?category.name:"Nessuna categoria"
                    }
                }).sort(function(x){
                    return x.is_main?-1:1
                });
        },
        eventTypes(){
            var self = this;
            return this.$hisport.getEnumAsDictionary(this.$hisport.event_types)
                    .filter(function(x){return x.id != self.$hisport.event_types.UNDEFINED})
        },
        min_date(){
            if(!this.event) return;
            if(this.event.video) return;
            return this.getStartTimestamp();
        },
    },
    watch: {
        async event(){
            if(!this.event) return;
            if(this.event.team_home)
                this.team_home = this.event.team_home;
            else if(this.event.name_team_home)
                this.team_home = {name: this.event.name_team_home};
            else
                this.team_home = null;


            if(this.event.team_foreign)
                this.team_foreign = this.event.team_foreign;
            else if(this.event.name_team_foreign)
                this.team_foreign = {name: this.event.name_team_foreign};
            else
                this.team_foreign = null;

            await this.mapEvent()
            this.alignEndTimestamp()
        },
        game_field(){
            this.$emit('changed',this.game_field);
            this.updateSports();
            this.checkSchedules();
        },
        sport(){
            this.updateCategories();
        },
        category(){
            this.updateSeasons();
            this.team_home = {};
            this.team_foreign = {};
        },
        season(){
            this.foreign_teams.splice(0);
            if(!this.season || !this.season.id) return;
            var self = this;
            this.$hisport.datacontext.team.getBySeasonId(this.season.id)
            .then(function(foreign_teams){
                self.foreign_teams = foreign_teams;
            })
        },
        start_immediately(){
            this.alignEndTimestamp()
            this.checkSchedules();
        },
        start_timestamp(){
            this.alignEndTimestamp()
            this.checkSchedules();
        },
        duration(){
            this.alignEndTimestamp()
            this.checkSchedules();
        }
    },
    methods: {
        alignEndTimestamp(){
            if(this.start_immediately){
                this.end_timestamp = moment(new Date()).add(this.duration,"minutes").toJSON();
            }else{
                this.end_timestamp = moment(this.start_timestamp).add(this.duration,"minutes").toJSON();
            }
        },
        async init(){
            console.log("Load GameFields")
            if(this.$hisport.permissions.isAdmin()){
                await this.getAllGameFields();                    
            }else{
                await this.getMyGameFields();
            }

            if(this.$hisport.options.platform.CONFIGURATION.ENABLE_CLUBS){
                console.log("Load Teams - mine")
                await this.getMyTeams();

                console.log("Load Teams - all")
                await this.getAllTeams();

                console.log("Load Categories")
                await this.getCategories();
                
                console.log("Load Seasons")
                await this.getSeasons();

                console.log("Update Categories")
                await this.updateCategories();
            }

            console.log("Map Event")
            await this.mapEvent();
            this.$store.dispatch("setLoading", false);

            this.alignEndTimestamp()
            await this.checkSchedules();
        },

        isFormValid(){
            if(!this.scheduleValidation)                                return console.warn("no scheduleValidation");
            if(!this.game_field)                                        return console.warn("no game_field");
            if(!this.sport)                                             return console.warn("no sport");
            if(this.start_immediately){
                if(!this.game_field.id_hgbox)                           return console.warn("no game_field.id_hgbox");
                // var box = this.box_statuses[this.game_field.id_hgbox] 
                // if(!box)                                                return console.warn("no box");
                // if(!box.status || !box.online)                          return console.warn("no box online");
                // if(box.status.status != "NOT_RECORDING")                return console.warn("box is recording");
            }
            switch(this.event_type){
                case this.$hisport.event_types.MATCH:{
                    return  !!this.category && this.category.id>0 && 
                            !!this.team_home && this.team_home.name && this.team_home.name.length>0 &&
                            !!this.team_foreign && this.team_foreign.name && this.team_foreign.name.length>0;
                }
                case this.$hisport.event_types.TRAINING:{
                    return  !!this.category && this.category.id>0 && 
                            !!this.team_home && this.team_home.name && this.team_home.name.length>0;
                }
                case this.$hisport.event_types.OTHER_GENERIC_VIDEO:{
                    return  !!this.title.length>0;
                }
            }
            return true;
        },
        changeStart: function(args) {
            try{
                if(args.value.getTime() < Date.now()){
                    var old = this.start_timestamp;
                    var self = this;
                    setTimeout(function(){
                        self.start_timestamp = old;
                    }, 10)
                }
                this.start_timestamp = args.value.toJSON()
            }catch(ex){
                this.$hisport.trace({
                    event: "error.EventForm.changeStart",
                    data: ex
                })
            }
        },
        checkSchedules(){
            clearTimeout(this.schedTimeout)
            var self = this;
            this.checkingConflictedEvents = true;
            this.scheduleValidation = false;
            // this.conflicted_events = [];
            return new Promise(function(resolve, reject){
                var config = {
                    page_size: 999999,
                    column_filters: {
                        // 'video.id': {$isNull: true}
                    }
                };
                if(self.event){
                    config.column_filters.id = {$ne: self.event.id }
                }
                if(self.game_field){
                    config.column_filters.id_game_field = self.game_field.id;
                }
                if(self.start_immediately){
                    config.column_filters.start_timestamp = { $lte: new Date(Date.now() + self.duration * 60 * 1000).toJSON() }
                    config.column_filters.end_timestamp   = { $gte: new Date().toJSON() };
                }else{
                    config.column_filters.start_timestamp = { $lte: moment(self.start_timestamp).set({second:0}).add(self.duration,'minutes').toDate().toJSON() }
                    config.column_filters.end_timestamp   = { $gte: moment(self.start_timestamp).set({second:59}).toDate().toJSON() };
                }
                self.$hisport.datacontext.event.getAll(config)
                .then(function(response){
                    clearTimeout(self.schedTimeout)
                    if(!self.exited)
                        self.schedTimeout = setTimeout(self.checkSchedules, 30000);
                    self.checkingConflictedEvents = false;
                    self.conflicted_events = response.entries;
                    if(response.entries.length>0){
                        self.scheduleValidation = false;
                        resolve(response.entries);
                    }else{
                        self.scheduleValidation = true;
                        resolve([]);
                    }
                })
                .catch(function(error){
                    console.error("error.checkSchedules", error);
                    clearTimeout(self.schedTimeout)
                    if(!self.exited)
                        self.schedTimeout = setTimeout(self.checkSchedules, 30000);
                    self.checkingConflictedEvents = false;
                    self.conflicted_events = [];
                    self.scheduleValidation = true;
                    reject();
                })
            })
        },
        checkTimeStamp(){
            if(this.event && this.event.video && !this.$hisport.permissions.isAdmin()){
                var sts = moment(this.start_timestamp).toDate();
                var diff = -1 * moment().diff(sts);
                if(Math.abs(diff) < MIN_FUTURE_START || diff < 0){
                    this.start_timestamp = this.getStartTimestamp();
                }
            }
            this.checkSchedules()
        },
        getStartTimestamp(){
            return moment(new Date().getTime() + MIN_FUTURE_START).toJSON();
        },
        //#region "List loading"
        getAllGameFields(){
            var self = this;
            self.gf_progress = true;
            return this.$hisport.datacontext.entity.getAll({
                page_size: 999999,
                column_filters: {
                    entity_type: this.$hisport.entity_types.GAME_FIELD,
                    id_hgbox: {$isNull: false}
                },
                include: [
                    "logo",
                    "no-supporter",
                    "game_field.structure", 
                    // "game_field.users",
                    "game_field.teams",
                    "team.category", 
                    "structure.clubs",
                    // "game_field.events",
                    // "event.teams",
                    // "event.game_field",
                    // "event.video"
                ]})
            .then(function(response){
                self.gf_progress = false;
                var game_fields = response.entries;
                self.game_fields = game_fields;
                if(self.gameFieldId){
                    self.game_field = game_fields.find(x=>x.id == self.gameFieldId);
                }
                if(!self.game_field)
                    self.game_field = game_fields[0]
                // self.selectGameField(game_fields[0].id);
            })
            .catch(function(error){
                self.gf_progress = false;
                self.$hisport.trace({
                    event: "error.EventForm.getAllGameFields",
                    data: error
                })
                console.error("EventForm.getAllGameFields", error)
            })
        },
        getMyGameFields(){
            var self = this;
            self.gf_progress = true;
            return this.$hisport.datacontext.entity.getByUserId(this.$hisport.getUserId(), 
            {
                filter: {
                    entity_type: this.$hisport.entity_types.GAME_FIELD,
                    id_hgbox: {$isNull: false}
                },
                include: [
                    "no-supporter",
                    "game_field.structure", 
                    // "game_field.users",
                    "game_field.teams",
                    "team.category", 
                    "structure.clubs",
                    // "game_field.events",
                    // "event.teams",
                    // "event.game_field",
                    // "event.video"
                ]})
            .then(function(game_fields){
                self.gf_progress = false;
                if(game_fields.length>0){
                    self.game_fields = game_fields;
                    if(self.gameFieldId){
                        self.game_field = game_fields.find(x=>x.id == self.gameFieldId);
                    }
                    if(!self.game_field)
                        self.game_field = game_fields[0]
                }else{
                    alert(self.$hisport.i18n("NO_GAME_FIELDS"))
                }
            })
            .catch(function(error){
                self.gf_progress = false;
                self.$hisport.trace({
                    event: "error.EventForm.getMyGameFields",
                    data: error
                })
                console.error("EventForm.getMyGameFields", error)
            })
        },
        getCategories(){
            var self = this;
            return this.$hisport.datacontext.category.getAll({page_size: 99999})
                .then(function(categories){
                    self.all_categories = categories.entries;
                })
        },
        getSeasons(){
            var self = this;
            return this.$hisport.datacontext.season.getAll({page_size: 99999})
                .then(function(seasons){
                    self.all_seasons = seasons.entries;
                })
        },
        getAllTeams(){
            var self = this;
            return this.$hisport.datacontext.team.getAll({page_size: 99999})
                .then(function(teams){
                    self.all_teams = teams.entries;
                })
        },
        getMyTeams(){
            var self = this;
            return this.$hisport.datacontext.entity.getByUserId(this.$hisport.getUserId(), 
                        {
                            filter: {entity_type: this.$hisport.entity_types.CLUB },
                            include: ["club.teams"]
                        })
            .then(function(clubs){
                if(Array.isArray(clubs) && clubs.length > 0){
                self.home_teams = clubs.reduce(function(acc, c){
                    if(Array.isArray(c.teams)){
                    c.teams.forEach(function(t){
                        if(!acc.find(function(x){ return x.id == t.id })){
                        acc.push(t)
                        }
                    })
                    }
                    return acc;
                },[]);
                }
            })
        },
        //#endregion
        //#region "Combo/Select handlers"
        selectSport(){
            // if(this.sports.length<2) {
            //     return console.warn("Disabled select because" ,this.sports.length, "sports are supported");
            // }
            // var self = this;
            // this.$showModal(ListComboBox, {
            //     props:{
            //         title: self.$options.filters.i18n("SELECT_SPORT"),
            //         field_image: null,
            //         items: this.sports
            //     }
            // }).then(function(selected){
            //     if(selected){
            //         self.sport = self.sports.find(x=>x.id == selected.id);
            //     }
            // })
        },
        selectCategory(){
            // var self = this;
            // this.updateCategories();
            // if(this.categories.length == 0) return;
            // this.$showModal(ListComboBox, {
            //     props:{
            //         title: self.$options.filters.i18n("SELECT_CATEGORY"),
            //         field_image: null,
            //         items: this.categories
            //     }
            // }).then(function(selected){
            //     if(selected){
            //     self.category = self.categories.find(x=>x.id == selected.id);
            //     }
            // })
        },
        selectSeason(){
            // var self = this;
            // this.$showModal(ListComboBox, {
            //     props:{
            //         title: self.$options.filters.i18n("SELECT_SEASON"),
            //         field_image: null,
            //         items: this.seasons
            //     }
            // }).then(function(selected){
            //     if(selected){
            //     self.season = self.seasons.find(x=>x.id == selected.id);
            //     }
            // })
        },
        selectTeamHome(){
            // var self = this;
            // var teams = this.home_teams;
            // if(this.all_teams.length>0){
                // var teams = this.all_teams.filter(function(x){
                // return !self.category || x.id_category == self.category.id;
                // }).map(function(x){
                // var is_main = (!!self.home_teams.find(y=>y.id == x.id));
                // return {
                //     is_main: is_main,
                //     class:    is_main?'primary':'secondary',
                //     logo: x.logo,
                //     name: x.name,
                //     id: x.id
                // }
                // }).sort(function(x){
                // return x.is_main?-1:1
                // })
            // }
            // this.selectTeam(teams, this.team_home)
            //     .then(function(t){
            //     if(t){
            //         if(!t.is_main && t.id){
            //         setTimeout(function(){
            //             confirm(self.$options.filters.i18n('CONFIRM_NOT_HOME_TEAM'))
            //                 .then(function(result){
            //                 if(result)
            //                     self.team_home = t;
            //                 })
            //             .catch(function(error){
            //                 console.error("HomeTeam confirm error", error)

            //                 self.$hisport.trace({
            //                     event: "error.EventForm.homeTeamConfirm",
            //                     data: error
            //                 })
            //             })
            //         }, 1000);
            //         }else{
            //         self.team_home = t;
            //         }
            //     }
            //     })
            //     .catch(function(err){
            //     alert("ERROR " + err.toString())
            //     })
        },
        selectTeamForeign(){
            // var self = this;
            // var teams = this.all_teams.filter(function(x){
            //     return !self.category || x.id_category == self.category.id;
            //     }).map(function(x){
            //     var is_main = !!((!!self.home_teams.find(y=>y.id == x.id)) || (!!self.foreign_teams.find(y=>y.id == x.id)));
            //     return {
            //         is_main:  is_main,
            //         class:    is_main?'primary':'secondary',
            //         logo:     x.logo,
            //         name:     x.name,
            //         id:       x.id
            //     }
            // }).sort(function(x){
            //     return x.is_main?-1:1
            // });
            // this.selectTeam(teams, this.team_foreign)
            //     .then(function(t){
            //     if(t){
            //         if(!t.is_main && t.id){
            //         setTimeout(function(){
            //             confirm(self.$options.filters.i18n('CONFIRM_NOT_HOME_OR_FOREIGN_TEAM'))
            //             .then(function(result){
            //                 if(result)
            //                     self.team_foreign = t;
            //             })
            //             .catch(function(error){
            //                 console.error("ForeignTeam confirm error", error)

            //                 self.$hisport.trace({
            //                     event: "error.EventForm.foreignTeamConfirm",
            //                     data: error
            //                 })
            //             })
            //         },1000)
            //         }else{
            //         self.team_foreign = t;
            //         }
            //     }
            //     })
            //     .catch(function(err){
            //     alert("ERROR " + err.toString())
            //     })
        },
        selectTeam(/*teams, selected*/){
            // return this.$showModal(ListComboBox, {
            //     props:{
            //         title: "SELECT_TEAM",
            //         items: teams,
            //         selected: selected,
            //         editable: true
            //     }
            // })
        },
        //#endregion
        //#region "Update entity lists"
        updateSports(){
            var self = this;
            if(!this.game_field) return console.warn("NO GAME_FIELD");
            if(!Array.isArray(this.game_field.supported_sports)) return console.warn("NO SUPPORTED_SPORTS")
            this.sports = this.game_field.supported_sports.map(function(id_sport){
                return {
                    id: id_sport,
                    name: self.$hisport.getSportName(id_sport)
                }
            });
            this.sport = this.sports[0];
            // this.$nextTick(function(){
            //     self.$set(self,"sport",self.sports[0]);
            // })
        },
        updateCategories(){
            if(!this.$hisport.options.platform.CONFIGURATION.ENABLE_CATEGORIES) return;
            var self = this;
            if(this.sport != undefined)
                this.categories = this.all_categories.filter(function(x){
                return x.id_sport == self.sport.id;
                });
            else
                this.categories = this.all_categories;
            this.category = this.categories[0];
        },
        updateSeasons(){
            if(!this.$hisport.options.platform.CONFIGURATION.ENABLE_SEASONS) return;
            var self = this;
            if(this.category != undefined){
                this.seasons = this.all_seasons.filter(function(x){
                return  x.id_category == self.category.id &&
                        x.current;
                })
            }else{
                this.seasons = this.all_seasons;
            }
            this.season = this.seasons[0];
        },
        //#endregion
        //#region "Rec Actions"
        mapEvent(evt){
            var self = this;
            if(!evt) evt = this.event;
            return new Promise(function(resolve/*, reject*/){
                if(!evt) return resolve();
                try{
                self.start_timestamp    = moment(evt.start_timestamp).toDate().toJSON();
                self.end_timestamp      = moment(evt.end_timestamp).toDate().toJSON();
                }catch(ex){
                    alert("ERROR")
                    return console.error(ex)
                }
                self.visibility         = evt.visibility;
                self.game_field         = self.game_fields.find(x=>x.id == evt.id_game_field);
                self.event_type         = evt.event_type;
                self.password           = evt.password;
                var realDiff            = moment(self.end_timestamp).diff(moment(self.start_timestamp),"minutes")
                self.duration           = self.$hisport.options.EVENT_DURATIONS
                                            .sort(function(a,b){
                                                var adif = Math.abs(a.value - realDiff);
                                                var bdif = Math.abs(b.value - realDiff);
                                                if(adif<bdif) return -1;
                                                if(adif>bdif) return 1;
                                                return 0
                                            })[0].value
                self.sport              = Array.isArray(evt.sports) ?
                                            self.sports.find(x=>x.id == evt.sports[0]):{id: 0, name: "undefined sport"};
                self.title              = evt.title;
                self.team_foreign       = {id: evt.id_team_foreign,  name: evt.name_team_foreign };
                self.team_home          = {id: evt.id_team_home,     name: evt.name_team_home };
                self.season             = self.seasons.find(x=>x.id == evt.id_season);
                self.start_immediately  = false;
                self.has_video          = evt && evt.has_video;
                resolve();
            }) 
        },
        getNewEvent(){
            var self = this;
            return new Promise(function(resolve, reject){
                if(!self.game_field) 
                    return reject("NO_GAME_FIELD");
                if(!self.game_field.id_hgbox) 
                    return reject("NO_HGBOX_GAME_FIELD");
                if(!self.sport) 
                    return reject("NO_SPORT");
                
                var obj = {};
                if(self.start_immediately){
                    obj.start_timestamp   = new Date().toJSON();
                    obj.end_timestamp     = new Date(Date.now() + self.duration * 60 * 1000).toJSON();
                }else{
                    obj.start_timestamp   = moment(self.start_timestamp).set({second:59}).toDate().toJSON();
                    obj.end_timestamp     = moment(self.start_timestamp).add(self.duration,'minutes').set({second:0}).toDate().toJSON();
                }
                if(self.visibility == self.$hisport.visibility_types.PASSWORD){
                    if(self.password)
                        obj.password = self.password;
                    else
                        obj.password = self.$hisport.generatePassword(6);
                }
                obj.id                = self.event && self.event.id;
                obj.visibility        = self.visibility;
                obj.event_type        = self.event_type;
                obj.id_game_field     = self.game_field.id;
                obj.id_country        = self.game_field.id_country;
                obj.id_creator        = self.$hisport.getUserId();
                obj.game_field        = self.game_field;
                obj.team_foreign      = self.team_foreign;
                obj.team_home         = self.team_home;
                obj.category          = self.category;
                obj.season            = self.season;
                obj.sports            = [self.sport.id]
                obj.has_video         = self.has_video
                obj.chunks_upload     = self.chunks_upload

                var create_season     = false;
                switch(self.event_type){
                    case self.$hisport.event_types.MATCH:{
                        if(!self.category) 
                        return reject("NO_CATEGORY");
                        if(!self.team_home.id && !self.team_home.name)
                        return reject("NO_TEAM_HOME");
                        if(!self.team_foreign.id && !self.team_foreign.name)
                        return reject("NO_TEAM_FOREIGN");

                        obj.id_team_foreign = self.team_foreign.id;
                        obj.name_team_foreign = self.team_foreign.name;
                        obj.id_team_home = self.team_home.id;
                        obj.name_team_home = self.team_home.name;
                        obj.title = [self.team_home.name,"vs", self.team_foreign.name].join(" ");
                        if(self.season){
                            obj.id_season = self.season.id;
                        }else{
                        create_season = true;
                        }
                        break;
                    }
                    case self.$hisport.event_types.TRAINING:{
                        if(!self.category) 
                        return reject("NO_CATEGORY");
                        if(!self.team_home.id && !self.team_home.name)
                        return reject("NO_TEAM_HOME");
                        obj.id_team_home = self.team_home.id;
                        obj.name_team_home = self.team_home.name;
                        obj.title = [self.team_home.name, self.$options.filters.i18n("TRAINING")].join(" ");
                        
                        if(self.season){
                            obj.id_season = self.season.id;
                        }else{
                        create_season = true;
                        }
                        break;
                    }
                    case self.$hisport.event_types.OTHER_GENERIC_VIDEO:{
                        obj.title = self.title;
                        break;
                    }
                }
                if(create_season){
                    self.$hisport.datacontext.season.add({
                        current:      true,
                        id_category:  self.category.id,
                        id_sport:     self.sport.id,
                        name:         [self.$hisport.getSportName(self.sport.id), self.category.name, new Date().getFullYear(), "(auto)"].join(" "),
                        start_at:     new Date().toJSON(),
                        end_at:       new Date().toJSON()
                    })
                    .then(function(resp){
                        obj.id_season = resp.id;
                        resolve(obj)
                    })
                    .catch(function(error){
                        console.error("Season creation error", error);
                        self.$hisport.trace({
                            event: "error.EventForm.createSeason",
                            data: error
                        })
                        resolve(obj)
                    })
                }else{
                    resolve(obj);
                }
            })
        },
        // questo cancella solo l'entità sul database
        // deleteEvent(){
        //     if(!this.event) return;
        //     var self = this;
        //     if(confirm(this.$hisport.i18n("ARE_YOU_SURE_REMOVE_EVENT")))
        //         return self.$hisport.datacontext.event.remove(self.event.id)
        //                 .then(function() {
        //                     self.$hisport.datacontext.hiBox.job.syncCalendars(self.game_field.id_hgbox)
        //                 })
        //                 .then(function(){
        //                     alert(self.$hisport.i18n("EVENT_REMOVED_SYNCED"));
        //                     self.$router.replace({path: "/events"})
        //                 })
        //                 .catch(function(error){
        //                     alert(self.$hisport.i18n("ERROR_REMOVE_EVENT"))
        //                     console.error("error.deleteEvent", error)
        //                 })
        // },
        // questo metodo cancella entità, cartella locale e remota
        deleteEvent(){
            if(!this.event) return;
            var self = this;
            if(confirm(self.$hisport.i18n("ARE_YOU_SURE_REMOVE_EVENT"))){
                console.info("EVENTARELLOLLLO", self.event)
                if( (!self.event)                     ||
                    (!self.event.game_field)          ||
                    (!self.event.game_field.id_hgbox))
                    return alert("BOX_NOT_PROVIDED");

                /*
                    TODO se si tratta di un evento schedulato, l'evento potrebbe non essere mai lanciato e il video mai creato,
                    quindi potrebbe essere utile dividere le due cancellazioni di Event e Video
                */
                let promise = Promise.resolve();
                if(!self.event.video || !self.event.video.id_external) {
                    // cancellazione del solo evento
                    promise = self.$hisport.datacontext.event.remove(self.event.id);
                } else {
                    // cancellazione globale
                    promise = self.$hisport.datacontext.http.post("/uploads/delete/" + self.event.game_field.id_hgbox + "/" + self.event.video.id_external, {local: true, remote: true})
                }
                return promise
                            .then(function() {
                                self.$hisport.datacontext.hiBox.job.syncCalendars(self.game_field.id_hgbox)
                            })
                            .then(function(){
                                alert(self.$hisport.i18n("EVENT_REMOVED_SYNCED"))
                                self.$router.replace({path: "/events"})
                            })
                            .catch(function(error){
                                alert(self.$hisport.i18n("ERROR_REMOVE_EVENT"))

                                console.error("error.deleteEvent", error)
                            })
            }
        },
        cloneEvent(){
            let self = this;
            if(!self.event) return;
            self.$modal.show(
                ()=>import("../_components/modal_game_fields"),
                {
                    selections: self.game_fields,
                    onSelect(game_field){
                        if(game_field){
                            console.info(self.event.id, 'to', game_field.id)

                            let include = ["video", "game_field", "tags", "clips"]
                            return self.$hisport.datacontext.http.post('/events/clone/?include=['+include.map(x=>"\""+x+"\"")+']', {
                                id_game_field : game_field.id,
                                events        : [
                                    self.event.id
                                ]
                            })
                            .then(function(){
                                self.$modal.show(
                                    ()=>import("../_components/hg_modal"), 
                                    { info: "CLONE_STARTED_INFO"}
                                );
                                self.$modal.hide('game-field-select');
                                self.$router.replace({path: "/events"})
                            })
                            .catch(function(e){
                                alert(self.$hisport.i18n(e))
                            })
                        } else {
                            self.$modal.hide('game-field-select')
                        }
                    },
                },
                {
                    name: "game-field-select"
                }
            )
        },
        saveEvent(notify){
            var self = this;
            return new Promise(function(resolve, reject){
                if(!self.isFormValid()){
                    if(notify)
                        alert(self.$hisport.i18n("FORM_INVALID"));
                    return reject("FORM_INVALID");
                }
                self.launching = true;
                self.evt_processing = true;
                self.getNewEvent()
                    .then(function(evt){
                        if(evt.id)
                            return self.$hisport.datacontext.event.update(evt);
                        else
                            return self.$hisport.datacontext.event.add(evt);
                    })
                    .then(function(res){
                        self.launching = false;
                        resolve(res);
                        if(notify){
                            self.$hisport.datacontext.hiBox.job.syncCalendars(self.game_field.id_hgbox)
                            .then(function(){
                                return alert(self.$hisport.i18n("EVENT_SAVED_SYNCED"));
                            })
                            .catch(function(error){
                                self.$hisport.trace({
                                    event: "error.EventForm.syncCalendar",
                                    data: error
                                }, self.game_field.id_hgbox)
                                alert(self.$hisport.i18n("EVENT_SAVED_BUT_NO_SYNCED"));
                            })
                            .then(function(){
                                if(!self.event)
                                    self.$router.push("/events/calendar")
                                else{
                                    self.mapEvent(res)
                                }
                                self.evt_processing = false;
                                    // self.$navigateTo(EventDetail, { clearHistory: true, props: { eventId: res.id}});
                            })
                        }else{
                            self.evt_processing = false;
                        }
                    })
                    .catch(function(error){
                        self.evt_processing = false;
                        self.$hisport.trace({
                            event: "error.EventForm.saveEvent",
                            data: error
                        })
                        self.launching = false;
                        reject(error);
                        if(notify){
                            alert(self.$hisport.i18n("EVENT_ERROR"));
                        }
                    })
            })
        },
        saveAndStartRecording(){
            var self = this;
            return self.isHiGoalBoxIdle()
                .then(function() {
                    return self.saveEvent(false)
                        .catch(function(error){
                            self.$hisport.trace({
                                event: "error.EventForm.saveAndStartRecording",
                                data: error
                            })                        
                            alert(self.$hisport.i18n("EVENT_ERROR"));
                        })
                })
                .then(function(response){
                    self.startEventRecording(response);
                })
                .catch(function(error) {
                    alert(self.$options.filters.i18n(error && error.status))
                    self.$hisport.trace({
                        event: "error.EventForm.startEventRecording",
                        data: error
                    })
                    self.launching = false;
                })
        },
        isHiGoalBoxIdle(){
            var self = this;
            return new Promise(function(resolve, reject){
                return self.$hisport.datacontext.hiBox.recording.getStatus(self.game_field.id_hgbox)
                .then(function(response){
                    if(response && response.status == "NOT_RECORDING"){
                        return resolve(response)
                    }else{
                        return reject(response)
                    }
                })
                .catch(reject)
            })
        },
        startEventRecording(event){
            var self = this;
            this.launching = true;
                return self.$hisport.datacontext.event.startRecording(event.id, {
                    maxDuration: self.duration,
                    chunksUpload: self.chunks_upload
                })
            .then(function(){
                setTimeout(function(){
                    self.$router.push("/events/" + event.id + "/edit")
                    // self.$navigateTo(EventLiveTag,{
                    // // clearHistory: true,
                    // props: { eventId: event.id}
                    // });
                    self.launching = false;
                }, 1000)
            })
            .catch(function(/* error */){
                // alert(self.$options.filters.i18n("HIGOALBOX_BUSY"))
                // self.$hisport.trace({
                //     event: "error.EventForm.startEventRecording",
                //     data: error
                // })
                self.launching = false;
            })
        },
        checkAndSave(notify) {
            var self = this;
            return self.isHiGoalBoxIdle()
                .then(function() {
                    return self.saveEvent(notify)
                })
                .then(function(res) {
                    console.log('ok', res)
                })
                .catch(function(error) {
                    alert(self.$options.filters.i18n(error && error.status))
                    self.$hisport.trace({
                        event: "error.EventForm.startEventRecording",
                        data: error
                    })
                    self.launching = false;
                })
        }
        //#endregion
    }
}
</script>
<style>
.event-form .buttons{
    margin-top:10px;
}
.checkbox{
    margin-top: 1rem;
}
.event-form .hg-select{
    line-height:0;
    margin:0;
    cursor: pointer;
}
.event-form .vs__selected{
    padding:0;
    margin:0;
}
.event-form .vs__selected>span>img,
.event-form .vs__selected>img{
    margin:0px;
    position:absolute;
    /* top:-6px;
    left:1px;
    height:34px;
    width:34px; */
}
.event-form .vs__selected>span>img+:not(img),
.event-form .vs__selected>img+:not(img){
    margin-left: 30px;
}
.event-form .vs__selected .pull-right{
    position:absolute;
    right:20px;
    color:red;
}
</style>